<div class="description__background"></div>
<div class="description__container">
  <section class="description__card">
    <header class="card__header">
      <div class="header__picture">
        <img *ngIf="logo" class="mb-2" [src]="logo" alt="" />
        <p class="header__subtitle">
          {{ 'organizer.description.registered' | translate }} :
          <time [attr.datetime]="createdAt | localizedDate: 'y-MM-dd'">{{
            formattedCreatedAtDate
          }}</time>
        </p>
      </div>
      <div class="header__content">
        <h1 class="header__title" aria-label="organization name">
          {{ name }}
        </h1>
        <ul>
          <li class="flex items-center mb-2">
            <vtmn-play-icon
              [name]="icon?.User"
              [height]="18"
              [width]="18"
            ></vtmn-play-icon>
            <span class="mx-1 text-sm text-black">{{
              'organizer.description.identity' | translate
            }}</span>
            <vtmn-play-icon
              ngClass="text-success"
              [name]="icon?.Check"
            ></vtmn-play-icon>
          </li>
          <li class="flex items-center mb-2">
            <vtmn-play-icon
              [name]="icon?.Mail"
              [height]="18"
              [width]="18"
            ></vtmn-play-icon>
            <span class="mx-1 text-sm text-black">{{
              'organizer.description.mail' | translate
            }}</span>
            <vtmn-play-icon
              ngClass="text-success"
              [name]="icon?.Check"
            ></vtmn-play-icon>
          </li>
          <li class="flex items-center">
            <vtmn-play-icon
              [name]="icon?.Phone"
              [height]="18"
              [width]="18"
            ></vtmn-play-icon>
            <span class="mx-1 text-sm text-black">{{
              'organizer.description.phone' | translate
            }}</span>
            <vtmn-play-icon
              ngClass="text-success"
              [name]="icon?.Check"
            ></vtmn-play-icon>
          </li>
        </ul>
      </div>
      <app-global-review
        [title]="'organizer.description.global_review' | translate"
        [globalNote]="averageRating"
        [totalReviews]="
          'activity.reviews.count-reviews'
            | translate: { reviewQuantity: reviewCount?.toString() || 0 }
        "
        *appIsEnabled="toggleNameEnum.OrganizerPageDescriptionReview"
        class="header__review"
      ></app-global-review>
    </header>
    <app-divider></app-divider>
    <span class="description__title">
      {{ 'organizer.description.description_title' | translate }} :
    </span>
    <p class="description__text" [innerText]="description"></p>
  </section>
</div>
